import React, { useState } from 'react';
import './HomePage.css';

const API = process.env.REACT_APP_API_URL || '';

export default function HomePage({ navigate }) {
  const [videoUrl, setVideoUrl] = useState('');
  const [userName, setUserName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!videoUrl.trim()) {
      setError('Вставьте ссылку на видео');
      return;
    }
    
    // Проверяем поддерживаемые платформы
    const isRutube = videoUrl.includes('rutube.ru/video/');
    const isYouTube = videoUrl.includes('youtube.com/watch') || 
                     videoUrl.includes('youtu.be/') || 
                     videoUrl.includes('youtube.com/embed') ||
                     videoUrl.includes('youtube.com/shorts');
    
    if (!isRutube && !isYouTube) {
      setError('Поддерживаются ссылки Rutube (rutube.ru/video/...) и YouTube');
      return;
    }
    
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API}/api/rooms`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ videoUrl, userName }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Ошибка создания комнаты');
      if (userName) sessionStorage.setItem('watchparty_username', userName);
      navigate(`/room/${data.roomId}`);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="home-page">
      <div className="home-bg">
        <div className="home-bg-grid" />
        <div className="home-bg-glow" />
      </div>

      <div className="home-content">
        <header className="home-header">
          <div className="home-logo">
            <span className="logo-icon">▶</span>
            <span className="logo-text">WATCHPARTY</span>
          </div>
          <p className="home-subtitle">Смотрите видео вместе!</p>
        </header>

        <div className="home-card">
          <div className="home-card-label">НОВАЯ КОМНАТА</div>
          <form onSubmit={handleCreate} className="home-form">
            <div className="form-group">
              <label className="form-label">Ссылка на видео</label>
              <input
                className="form-input"
                type="text"
                placeholder="https://rutube.ru/video/... или https://youtube.com/watch?v=..."
                value={videoUrl}
                onChange={e => { setVideoUrl(e.target.value); setError(''); }}
                autoFocus
              />
            </div>
            <div className="platform-hint">
              <span className="platform-badge rutube">Rutube</span>
              <span className="platform-badge youtube">YouTube</span>
            </div>
            {error && <div className="form-error">{error}</div>}
            <button className="btn-create" type="submit" disabled={loading}>
              {loading ? (
                <span className="btn-loading"><span className="dot" /><span className="dot" /><span className="dot" /></span>
              ) : (
                <>
                  <span className="btn-icon">▶</span>
                  Создать комнату
                </>
              )}
            </button>
          </form>
        </div>

        <div className="home-features">
          <div className="feature">
            <span className="feature-icon">⚡</span>
            <span>Мгновенная синхронизация</span>
          </div>
          <div className="feature">
            <span className="feature-icon">💬</span>
            <span>Текстовый чат</span>
          </div>
          <div className="feature">
            <span className="feature-icon">🎤</span>
            <span>Голосовой чат</span>
          </div>
        </div>
      </div>
    </div>
  );
}